/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetOrgMembersOptions, AdminGetOrgMembersResponses } from '../../models/AdminGetOrgMembers'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get all members of the org.
 * @summary Get Org Members
 * {@link /admin/org/:org_id/members}
 */
export function adminGetOrgMembers<ThrowOnError extends boolean = true>(options: Options<AdminGetOrgMembersOptions, ThrowOnError>): Promise<UnwrappedResult<AdminGetOrgMembersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/org/{org_id}/members', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetOrgMembersResponses, ThrowOnError>>
}
